export const formConstants = {
  ATTACH_SUCCESS: "ATTACH_SUCCESS",
  SELECT_SUCCESS: "SELECT_SUCCESS",
  DESELECT_SUCCESS: "DESELECT_SUCCESS",
  DELETE_SUCCESS: "DELETE_SUCCESS",
  TRANSFER_SUCCESS: "TRANSFER_PAGE_SUCCESS",
  SOFT_UPDATE_SUCCESS: "SOFT_UPDATE_SUCCESS",
  SELECT_OPTION: "SELECT_OPTION",
  UPDATE_FORM_SUCCESS: "UPDATE_FORM_SUCCESS",
  UPDATE_FORM_REQUEST: "UPDATE_FORM_REQUEST",
  UPDATE_FORM_FAILURE: "UPDATE_FORM_FAILURE",

  GET_FORM_REQUEST: "GET_FORM_REQUEST",
  GET_FORM_SUCCESS: "GET_FORM_SUCCESS",
  GET_FORM_FAILURE: "GET_FORM_FAILURE",

  GETALL_FORM_REQUEST: "GETALL_FORM_REQUEST",
  GETALL_FORM_SUCCESS: "GETALL_FORM_SUCCESS",
  GETALL_FORM_FAILURE: "GETALL_FORM_FAILURE",

  GET_ALL_FORM_PATHS: 'GET_ALL_FORM_PATHS',

  CLEAR_DND_CONFLICTS: "CLEAR_DND_CONFLICTS",
  CREATE_FORM_REQUEST: "CREATE_FORM_REQUEST",
  CREATE_FORM_SUCCESS: "CREATE_FORM_SUCCESS",
  CREATE_FORM_FAILURE: "CREATE_FORM_FAILURE",

  DELETE_FORM_SUCCESS: "DELETE_FORM_SUCCESS",
  DELETE_FORM_REQUEST: "DELETE_FORM_REQUEST",
  DELETE_FORM_FAILURE: "DELETE_FORM_FAILURE",
  IS_CROPPING: "IS_CROPPING",
  POST_FORM_REQUEST: "POST_FORM_REQUEST",
  POST_FORM_SUCCESS: "POST_FORM_SUCCESS",
  POST_FORM_FAILURE: "POST_FORM_FAILURE",

  UPDATE_FORM_ELEMENT: "UPDATE_FORM_ELEMENT",

  FORM_IS_VALID: "FORM_IS_VALID",
  RESTORE_FORM: "RESTORE_FORM",

  ADD_PAGE: "ADD_PAGE",
  REMOVE_PAGE: "REMOVE_PAGE",
  SCROLL_PAGE: "SCROLL_PAGE",
  SET_STATE_ERROR: "SET_STATE_ERROR",
  FORM_VERSION_CONFLICT: "FORM_VERSION_CONFLICT",


  //ERROR MESSAGE


  JX_FORM_VERSION_CONFLICT: "JX_FORM_VERSION_CONFLICT"


};
